import template from './pizza.html';

class controller{}

export const PizzaComponent = {
	    bindings: {
	        pizza: '<'
	    },
	    template,
	    controller,
	}


// WEBPACK FOOTER //
// ./src/pizza.component/index.js